import { api, ApiRequestConfig } from 'api';
import { AllBrands, FetchBrandsProps } from '../types';

export type GetBrandsConfig = {
  host: string;
  params: FetchBrandsProps;
  config?: ApiRequestConfig;
};

export const getBrands = async ({ host, params, config }: GetBrandsConfig) =>
  api.get<AllBrands>(`${host}/get-brands`, params, config);
